import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessor, FormControl } from '@ngneat/reactive-forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: FormInputComponent
    }
  ]
})
export class FormInputComponent extends ControlValueAccessor<string> {

  control = new FormControl('');

  @Input() valueType = 'text';
  @Input() placeholder = '';
  @Input() label = '';

  override writeValue(value: string): void {
    this.control.setValue(value, { emitEvent: false });
  }

  override registerOnChange(fn: ControlValueAccessor['onChange']): void {
    this.control.valueChanges.pipe(untilDestroyed(this)).subscribe(fn);
  }

  setDisabledState(isDisabled: boolean): void {
    this.control.setDisable(isDisabled);
  }

}
